import axios from "axios";

// const headers = {
//   "Content-Type": "application/json",
//   Authorization: `Bearer ${localStorage.getItem("token")}`,
// };

function getHeaders() {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
}

function getHeaders2() {
  return {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
}

export const getAdminNotification = async (id) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/notifications/notifications/admin/${id}/`
    );
    return response;
  } catch (err) {
    console.log(err);
  }
};

export const createLead = async (form) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/lead/api/`,
      [form],
      getHeaders()
    );
    return response;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const LeadTable = async () => {
  // "Data being sent to API:", form); // Debugging line
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/lead/api/`,
    getHeaders()
  );
  return response;
};
export const LeadCards = async () => {
  // "Data being sent to API:", ); // Debugging line
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/lead/api/`,
    getHeaders()
  );
  return response;
};

export const createTask = async (form) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/to_do_task/todotask/`,
      form,
      getHeaders()
    );
    return response;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const uploadUniversities = async (data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/student/shortlisting/`,
      data,
      getHeaders()
    );
    return response;
  } catch (err) {
    console.log(err);
  }
};

export const getTasks = async () => {
  try {
    // "response:", response);
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/to_do_task/todotask/`,
      getHeaders()
    );
    return response;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const getStudents = async () => {
  // "response:", response);
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/student/student_profile/`,
    getHeaders()
  );
  return response;
};

export const retrieveStudentDetails = async (id) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/student/student_profile/${id}/`,
    getHeaders()
  );

  return response;
};

export const register = async (form) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/user/register/`,
    form,
    getHeaders()
  );
  return response;
};

export const getStudent = async () => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/user/register/`,
    getHeaders()
  );
  return response;
};

export const markNotificationAsRead = async (notificationId) => {
  // If your URL is '/notifications/mark-as-read/<id>/' exactly:
  return axios
    .get(`/notifications/mark-as-read/${notificationId}/`)
    .then((res) => res.data)
    .catch((err) => {
      console.error("Mark as read error:", err);
      throw err;
    });
};

// Mark all notifications as read
export const markAllNotificationsAsRead = async (userId) => {
  return axios
    .get(`/notifications/mark-all-as-read/${userId}/`)
    .then((res) => res.data)
    .catch((err) => {
      console.error("Mark all as read error:", err);
      throw err;
    });
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/user/admin-profile/`,
      getHeaders()
    );
    return response;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const getAdmins = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/user/admin-profile/`,
      getHeaders()
    );
    return response;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};
// export const updateAdmin = async (id, formData) => {
//   try {
//     const response = await axios.patch(
//       `${process.env.REACT_APP_BASE_URL}/user/admin-profile/${id}/`,
//       formData,
//       getHeaders()
//     );
//     "updateAdmin", response.data);

//     return response.data;
//   } catch (error) {
//     console.error("Error updating admin profile:", error);
//     throw error;
//   }
// };
export const updateAdmin = async (id, formData) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/user/register/${id}/`,
      formData,
      getHeaders()
    );

    return response.data;
  } catch (error) {
    console.error("Error updating admin profile:", error);
    throw error;
  }
};

export const getSuperAdmin = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/user/superadmin-profile/`,
      getHeaders()
    );
    return response;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const getChatNotifications = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/chat_app/notifications/`,
      getHeaders()
    );

    return response;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const finalizeUniversity = async (
  student_id,
  finalizedData,
  note = ""
) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/student/shortlisting/toggle-finalised/`,
      { student_id: student_id, status: finalizedData, note },
      getHeaders()
    );

    return response;
  } catch (err) {
    console.error(err);
  }
};

export const deleteShortlistingRow = async (studentId, entryId) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/student/shortlisting/?student_id=${studentId}&entry_id=${entryId}`,
      getHeaders()
    );
    return response;
  } catch (err) {
    console.error(err);
  }
};

export const EditTasks = async (task_id, newTask) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_BASE_URL}/to_do_task/todotask/`,
      { ...newTask },
      getHeaders()
    );

    return response.data; // Return the response data to the caller
  } catch (error) {
    // Handle errors and log for debugging
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error; // Rethrow the error for handling in the calling component
  }
};
export const deleteTask = async (taskId) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/to_do_task/todotask/${taskId}/`, // Your API URL
      getHeaders()
    );

    return response.data; // Return the response data after task is deleted
  } catch (error) {
    console.error("Error deleting task:", error); // Log errors
    throw error; // Propagate error
  }
};

export const addFinalizedlistingEntry = async (studentId, entry) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/student/${studentId}/is-finalized-excel/`,
      {
        student_id: studentId,
        is_finalized_excel: entry,
      },
      getHeaders()
    );

    return response.data;
  } catch (error) {
    console.error("Error updating shortlisting entry:", error);
    throw error;
  }
};

export const updateShortlistingEntry = async (
  studentId,
  entryId,
  updatedEntry
) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_BASE_URL}/student/shortlisting/`,
      {
        student_id: studentId,
        entry_id: entryId,
        updated_entry: updatedEntry,
      },
      getHeaders()
    );

    return response.data;
  } catch (error) {
    console.error("Error updating shortlisting entry:", error);
    throw error;
  }
};

// Function to delete a student (example for deletion)
// export const deleteStudent = async (studentId) => {
//   try {
//     const response = await axios.delete(
//       `${process.env.REACT_APP_BASE_URL}/student/student_profile/${studentId}/`,
//       getHeaders()
//     );
//     return response.data;
//   } catch (error) {
//     console.error("Error deleting student:", error);
//     throw error;
//   }
// };

// Function to add a new student shortlisting entry
export const addShortlistingEntry = async (studentId, newEntry) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/student/shortlisting/`,
      {
        student_id: studentId,
        shortlisting: newEntry,
      },
      getHeaders()
    );

    return response.data;
  } catch (error) {
    console.error("Error adding shortlisting entry:", error);
    throw error;
  }
};

export const sendShortlistingNotification = async (studentId) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/student/shortlisting-notification/`,
      {
        student_id: studentId,
      },
      getHeaders()
    );
    return response.data;
  } catch (error) {
    console.error("Error adding application column:", error);
    throw error;
  }
};

export const sendFinalizedNotification = async (studentId) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/student/finalized-notification/`,
      {
        student_id: studentId,
      },
      getHeaders()
    );
    return response.data;
  } catch (error) {
    console.error("Error adding application column:", error);
    throw error;
  }
};

export const postFinalizedData = async (studentId, data) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/student/${studentId}/is-finalized-excel/`,
      { student_id: studentId, is_finalized_excel: data },
      getHeaders()
    );

    return response.data;
  } catch (error) {
    console.error("Error adding shortlisting entry:", error);
    throw error;
  }
};
export const getPostFinalizedData = async () => {
  // getHeaders());
  // id);
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/student/api/universities/`,
    getHeaders()
  );

  return response;
};

export const overwriteShortlisting = async (
  studentId,
  newShortlistingArray
) => {
  return await axios.put(
    `${process.env.REACT_APP_BASE_URL}/student/shortlisting/`,
    {
      student_id: studentId,
      shortlisting: newShortlistingArray,
    },
    getHeaders()
  );
};

export const getAdminProfile = async (id) => {
  // getHeaders());
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/user/admin-profile/${id}/`,
    getHeaders()
  );
  return response;
};

export const updateSuperAdminProfile = async (id, formData) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_BASE_URL}/user/superadmin-profile/${id}/`,
      formData,
      getHeaders2()
    );
    return response.data;
  } catch (error) {
    console.error("Error updating admin profile:", error);
    throw error;
  }
};

export const updateAdminProfile = async (id, formData) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_BASE_URL}/user/admin-profile/${id}/`,
      formData,
      getHeaders2()
    );
    return response.data;
  } catch (error) {
    console.error("Error updating admin profile:", error);
    throw error;
  }
};

export const getStudentApplication = async (id) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/student/student_profile/${id}/`,
    getHeaders()
  );
  return response;
};

export const getStudentDetails = async (id) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/student/student_profile/${id}/`,
    getHeaders()
  );

  return response;
};
export const updateStudentText = async (id, formData) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/student/student_profile/${id}/`,
      formData,
      getHeaders2()
    );

    return response.data;
  } catch (error) {
    console.error("Error updating admin profile:", error);
    throw error;
  }
};

export const updateStudentProfile = async (id, formData) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/student/student_profile/${id}/`,
      formData,
      getHeaders2()
    );

    return response.data;
  } catch (error) {
    console.error("Error updating admin profile:", error);
    throw error;
  }
};

export const updateStudentProfileFromAdminSide = async (id, formData) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/student/student_profile/${id}/`,
      formData,
      getHeaders()
    );
    return response.data;
  } catch (error) {
    console.error("Error updating admin profile:", error);
    throw error;
  }
};
export const activateUserAccount = async (studentId) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/user/reactive/${studentId}/`,
      {},
      getHeaders()
    );

    return response.data;
  } catch (error) {
    console.error(`Error activating account:`, error);

    // Log additional error details for debugging
    if (error.response) {
      console.error("Error response status:", error.response.status);
      console.error("Error response data:", error.response.data);
    }

    throw error;
  }
};

export const deactivateUserAccount = async (studentId) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/user/deactive/${studentId}/`,
      {},
      getHeaders()
    );

    return response.data;
  } catch (error) {
    console.error(`Error deactivating account:`, error);

    // Log additional error details for debugging
    if (error.response) {
      console.error("Error response status:", error.response.status);
      console.error("Error response data:", error.response.data);
    }

    throw error;
  }
};
